import React, { useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import useSearchApi from '../hooks/useSearchAPI';
import './SearchResultPage.css';
import FollowUpBar from '../components/FollowUpBar';
import './MarkdownStyles.css';


export async function searchQueryLoader({ params }) {
  return params.searchQuery;
}

function SearchResultPage() {
  const initialQuery  = useLoaderData();
  const [searchQuery, setSearchQuery] = useState([{type: 'user', text: initialQuery}]);
  const { results, isLoading, error } = useSearchApi(searchQuery);

  const handleFollowUp = (query) => {
    setSearchQuery([...searchQuery, {type: 'ai', text: results}, {type: 'user', text: query}]); 
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className='search-result-page'>
      <div className="search-results-container">
          <h1 className="search-results-title">{searchQuery[searchQuery.length - 1].text}</h1>
          <div className="search-results-scrollview">
            {isLoading ? (
              <p>Your personalized travel itinerary is now being crafted...</p>
            ) : results.length === 0 ? (
              <p>No results found.</p>
            ) : (
              <div className="markdown-content">
                <ReactMarkdown>{results}</ReactMarkdown>
              </div>
            )}
            <div className="search-results-scrollview-bottom-bar"></div>
          </div>
          <FollowUpBar onSubmit={handleFollowUp}/>
      </div>
    </div>
  );
}

export default SearchResultPage;
